import PropTypes from 'prop-types';
import PanelHeader from '../sidebar/panelHeader/panelHeader';
import FigureGrid from './figureGrid';

export default function Figures({ figures }) {
  return (
    <div className="sidebar-scroll-panel sidebar-panel-default-appearance">
      <PanelHeader title={`Figures (${figures.length})`} />
      <div className="sidebar-scroll-panel-body" id="figure-panel">
        <FigureGrid figures={figures} />
      </div>
    </div>
  );
}

Figures.propTypes = {
  figures: PropTypes.arrayOf(PropTypes.shape({
    figure: PropTypes.shape({ small: PropTypes.string }),
    label: PropTypes.string,
  })).isRequired,
};
